import React from "react";
import { motion } from "framer-motion";

const Closing = () => {
  return (
    <section
      data-testid="closing-section"
      className="relative w-full bg-ink py-32 md:py-48 overflow-hidden"
    >
      <div className="watermark absolute -top-10 left-1/2 -translate-x-1/2 text-[14rem] sm:text-[20rem] md:text-[26rem] leading-none">
        ﷺ
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-12 text-center">
        <motion.span
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="block text-[11px] uppercase tracking-[0.4em] text-copper mb-8"
        >
          — Penutup
        </motion.span>

        <motion.blockquote
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
          data-testid="closing-quote"
          className="font-serif text-parchment leading-[1.1] tracking-tightest text-3xl md:text-5xl lg:text-6xl"
        >
          "Kita tidak hanya membaca sejarah —
          <br />
          <em className="text-copper not-italic">kita meneruskannya.</em>"
        </motion.blockquote>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2, delay: 0.4 }}
          className="mt-12 text-warm-muted font-light max-w-xl mx-auto leading-relaxed"
        >
          Setiap langkah Rasulullah ﷺ adalah cermin bagi perjalanan kita
          hari ini. Semoga shalawat dan salam senantiasa tercurah kepada
          beliau, keluarganya, dan para sahabatnya.
        </motion.p>
      </div>
    </section>
  );
};

export default Closing;
